import { styled } from '@mui/system'
import SubmitButton from '../../../../molecules/button/submit-button'

const CheckBoxWrapper = styled('div')`
	&.privacy-checkbox {
		margin-top: 20px;
	}

	.MuiFormControlLabel-root {
		align-items: flex-start;
		margin: 0;

		.MuiFormControlLabel-label {
			line-height: ${({ theme }) => theme.typography.checkbox.lineHeight};
		}
		.MuiCheckbox-root {
			padding-top: 10px;
		}
	}
`

const SubmitButtonStyled = styled(SubmitButton)`
	margin-top: 16px;
`

export { CheckBoxWrapper, SubmitButtonStyled }
